import { createSlice } from '@reduxjs/toolkit';

const subredditSlice = createSlice({
  name: 'subreddit',
  initialState: {
    items: [],
  },
  reducers: {
    setSubreddits(state, action) {
      state.items = action.payload;
    },
    addSubreddit(state, action) {
      state.items = [...state.items, action.payload];
    },
    removeSubreddit(state, action) {
      state.items = state.items.filter(
        subreddit => subreddit.toLowerCase() !== action.payload.toLowerCase()
      );
    },
  },
});

export const {
  addSubreddit,
  removeSubreddit,
  setSubreddits,
} = subredditSlice.actions;

export const selectSubreddits = state => state.subreddit.items;

export default subredditSlice.reducer;
